// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
  width: calc(100% - 61.8%); /* Golden ratio */
  height: 100vh;
  overflow-y: scroll;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  container-type: inline-size;

  color: #1d1625;;
  h1, h2, h3 {
    color: #1d1625;
  }

  p {
    padding: 8px 32px;
  }

  a {
    color: #64748b;
  }

  a:hover {
    color: #b91c1c;
  }

  a:visited {
    color: purple
  }

  a:visited:hover {
    color: #b91c1c;
  }
}

@media (max-width:1050px)  { 
  #sidebar {
    width: 100%;
    height: 61.8vh; /* golden ratio */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;;EAE3B,cAAc;EACd;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;EACF;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc,EAAE,iBAAiB;EACnC;AACF","sourcesContent":["#sidebar {\n  width: calc(100% - 61.8%); /* Golden ratio */\n  height: 100vh;\n  overflow-y: scroll;\n  background-color: #000000;\n  display: flex;\n  flex-direction: column;\n  container-type: inline-size;\n\n  color: #1d1625;;\n  h1, h2, h3 {\n    color: #1d1625;\n  }\n\n  p {\n    padding: 8px 32px;\n  }\n\n  a {\n    color: #64748b;\n  }\n\n  a:hover {\n    color: #b91c1c;\n  }\n\n  a:visited {\n    color: purple\n  }\n\n  a:visited:hover {\n    color: #b91c1c;\n  }\n}\n\n@media (max-width:1050px)  { \n  #sidebar {\n    width: 100%;\n    height: 61.8vh; /* golden ratio */\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
